import { render, staticRenderFns } from "./base-svg-icon.vue?vue&type=template&id=6e422de1"
import script from "./base-svg-icon.vue?vue&type=script&lang=js"
export * from "./base-svg-icon.vue?vue&type=script&lang=js"
import style0 from "./base-svg-icon.vue?vue&type=style&index=0&id=6e422de1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports